import Link from "next/link";
import { SingletonRouter, withRouter } from "next/router";
import React from "react";

interface Props {
  href: any;
  children: any;
  router: SingletonRouter;
  noParams?: boolean;
  withoutCurrency?: boolean;
}

const CustomLink = (props: Props) => {
  let { href } = props;
  if (typeof href === "string") {
    href = { pathname: props.href };
  }

  const { lang, currency, typeSearch } = props.router.query;

  href.query =
    !props?.noParams && (href.query || lang || currency || typeSearch)
      ? {
          ...href.query,
          ...(lang ? { lang } : {}),
          ...(props.withoutCurrency !== true && currency ? { currency } : {}),
          ...(typeSearch ? { typeSearch } : {}),
        }
      : undefined;

  return <Link href={href}>{props.children}</Link>;
};

export default withRouter(CustomLink);
